import { render, staticRenderFns } from "./BoardCards.vue?vue&type=template&id=1ba898e6&"
import script from "./BoardCards.vue?vue&type=script&lang=js&"
export * from "./BoardCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports